import { render, staticRenderFns } from "./QuizzChoices.vue?vue&type=template&id=1a794c7a&"
import script from "./QuizzChoices.vue?vue&type=script&lang=ts&"
export * from "./QuizzChoices.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports